import script from "./Products.vue?vue&type=script&setup=true&lang=js"
export * from "./Products.vue?vue&type=script&setup=true&lang=js"

import "./Products.vue?vue&type=style&index=0&id=ad3b5caa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad3b5caa"]])

export default __exports__